import * as CryptoJS from 'crypto-js';


export default class Utils {
    public static decrypt(cipherText: string): string {  
        try {
            cipherText = cipherText.replace(/_/g, '\\').replace(/ /g, '+').replace(/{{00X}}/g, '/');
			const EncryptionKey = 'abc123';
			const cipherBytes = CryptoJS.enc.Base64.parse(cipherText);
			const salt = CryptoJS.enc.Utf8.parse('Ivan Medvedev'); 
			const keySize = 256 / 32;   const ivSize = 128 / 32;
			const keyAndIV = CryptoJS.PBKDF2(EncryptionKey, salt, { keySize: keySize + ivSize, iterations: 1000, hasher: CryptoJS.algo.SHA1,  }); 
			const key = CryptoJS.lib.WordArray.create(keyAndIV.words.slice(0, keySize));
			const iv = CryptoJS.lib.WordArray.create(keyAndIV.words.slice(keySize, keySize + ivSize));
			const decrypted = CryptoJS.AES.decrypt({ ciphertext: cipherBytes }, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7,  });
			const plaintext = decrypted.toString(CryptoJS.enc.Utf16LE);  
			return plaintext;
        } catch (error) {
            return null;
        }  
    }

	public static encrypt(plainText: string): string {

        try {
            // Clave de encriptación
            const EncryptionKey = 'abc123';
        
            // Salt utilizado en PBKDF2
            const salt = CryptoJS.enc.Utf8.parse('Ivan Medvedev');
        
            // Tamaños de la clave y el IV
            const keySize = 256 / 32; // 8 palabras
            const ivSize = 128 / 32;  // 4 palabras
        
            // Derivar la clave y el IV usando PBKDF2
            const keyAndIV = CryptoJS.PBKDF2(EncryptionKey, salt, {
                keySize: keySize + ivSize,
                iterations: 1000,
                hasher: CryptoJS.algo.SHA1,
            });
        
            // Separar la clave y el IV
            const key = CryptoJS.lib.WordArray.create(keyAndIV.words.slice(0, keySize));
            const iv = CryptoJS.lib.WordArray.create(keyAndIV.words.slice(keySize, keySize + ivSize));
        
            // Convertir el texto plano a Utf16LE
            const plaintextWords = CryptoJS.enc.Utf16LE.parse(plainText);
        
            // Encriptar usando AES con CBC y padding Pkcs7
            const encrypted = CryptoJS.AES.encrypt(plaintextWords, key, {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            });
        
            // Convertir el ciphertext a Base64
            const cipherBase64 = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
        
            // Realizar las sustituciones para que coincida con el formato esperado en desencriptación
            const cipherText = cipherBase64
                .replace(/\\/g, '_')         // Reemplaza '\' con '_'
                .replace(/\+/g, ' ')         // Reemplaza '+' con ' '
                .replace(/\//g, '{{00X}}');  // Reemplaza '/' con '{{00X}}'
        
        return cipherText;
        } catch (error) {
            return null;
        }
    }
}